export default __webpack_public_path__ + "static/media/arrow-down.5611c2d4.svg";